/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Form_Hint1Inputs */

const vi_guidevideo_form_hint1 = /** @type {(inputs: Guidevideo_Form_Hint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn video mp4 trong Thư viện ảnh (hoặc tải lên ngay trong hộp chọn), đặt tiêu đề và nhóm.`)
};

/**

* @param {Guidevideo_Form_Hint1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_form_hint1 = /** @type {((inputs?: Guidevideo_Form_Hint1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Form_Hint1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_form_hint1(inputs)
});
export { guidevideo_form_hint1 as "guideVideo_form_hint" }